import { createMarker } from '@/utils/mapService'

export default {
  attachMapTooltip: {
    methods: {
      attachMapTooltip ({ parent, layer, textName }) {
        const marker = createMarker({
          coordinates: layer.getCenter(),
          options: {
            symbol: {
              textFill: '#ff0',
              textSize: 15,
              textName,
              textOpacity: 0.75,
              textHaloFill: '#000',
              textHaloRadius: 2
            },
            properties: {
              altitude: 300 + Math.random() * 200
            }
          }
        })
        marker.addTo(parent)

        this.mapMarker = marker
      }
    }
  }
}
